import attendanceTeacherCreate from "@/controllers/attendance_teacher/attendance-teacher-create";
import axios from "axios";

export default {
  extends: attendanceTeacherCreate,
  data() {
    return {
      searchData: {
        employeeId: this.auth('teacher').user()?.employee_id ?? 0,
        startDate: "",
        endDate: "",
      },
    };
  },
  methods: {
    getEmployeeNameList() {
      if (this.auth('teacher').check()) {
        this.isLoading = false;
        return;
      }

      axios.get("/employee/list", {
        params: {
          exclude_admin_hr: true,
        },
      })
        .then((response) => {
          const employees = response.data.data || [];
          if (employees.length > 0) {
            this.teacherArr = [{ id: 0, text: "Select Employee" }].concat(
              employees.map((emp) => ({
                id: emp.id,
                text: `${emp.employee_code} - ${emp.name} (${emp.employeeable_type_text})`,
              }))
            );
          }
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        })
        .finally(() => this.isLoading = false);
    },
  },
};
